import * as React from 'react';
import { FontIcon, withBaseProps, Loading } from '@topconagriculture/react-components';
import { createStyles } from '@material-ui/styles';
import { compose } from 'recompose';
import { border, transition } from '@topconagriculture/theme';
import { Badge } from '@material-ui/core';
const styles = (theme) => createStyles({
    userMenuButtonWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '13px 20px',
        backgroundColor: theme.color.background.light,
        width: '100%',
        color: theme.color.font.dark,
        transition: transition(80),
        borderBottom: border(theme.color.grey.lightest),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.color.primary.main,
            color: theme.color.font.light,
        },
        '&:hover $buttonIcon': {
            color: theme.color.font.light,
        },
        '&:active': {
            backgroundColor: theme.color.primary.light,
        },
        '&:last-child': {
            borderBottom: 'none',
            borderRadius: '0 0 5px 5px',
        },
    },
    buttonIcon: {
        color: theme.color.font.dark,
    },
    buttonText: {
        marginLeft: 20,
        fontSize: 14,
        letterSpacing: 1.2,
        textTransform: 'uppercase',
        textOverflow: 'ellipsis',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
    },
});
const UserMenuButton = (props) => {
    const { classes, icon, children, onClick, testId = children, isLoading, badge } = props;
    return (React.createElement("div", { role: "button", className: classes.userMenuButtonWrapper, onClick: onClick || null, "data-testid": `user-menu-button-${testId}` },
        React.createElement(Badge, { color: "error", badgeContent: badge },
            React.createElement(FontIcon, { className: classes.buttonIcon, top: 3, iconName: icon })),
        React.createElement("div", { title: children, className: classes.buttonText }, children),
        React.createElement(Loading, { isLoading: !!isLoading, size: 24 })));
};
export default compose(withBaseProps({ styles }))(UserMenuButton);
//# sourceMappingURL=UserMenuButton.js.map